import { render } from "./ShippingModal.vue?vue&type=template&id=314b404a"
import script from "./ShippingModal.vue?vue&type=script&lang=js"
export * from "./ShippingModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__